import React, { useEffect, useState } from 'react';
import './AddTutorContainer.scss';
import { FormControl, TextField, Select, MenuItem, Autocomplete, Chip } from '@mui/material';
import { createTutor, updateTutor } from '../../data/api';
import { Bounce, ToastContainer, toast } from 'react-toastify';

const CAREERS = [
  { value: '9',  label: 'Ingeniería Electrónica' },
  { value: '31', label: 'Ingeniería Civil' },
  { value: '7',  label: 'Ingeniería Eléctrica' },
  { value: '27', label: 'Ingeniería Química' },
  { value: '17', label: 'Ingeniería Mecánica' },
  { value: '24', label: 'Ingeniería Industrial' },
  { value: 'H',  label: 'Homogéneas' },
];

export const AddTutorContainer = ({ toggle, existingTutor }) => {
  const [name, setName] = useState(existingTutor?.name || '');
  const [selectedCareer, setSelectedCareer] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState(existingTutor?.subjects || []);
  const [pricePerHour, setPricePerHour] = useState(existingTutor?.pricePerHour || '');
  const [description, setDescription] = useState(existingTutor?.description || '');
  const [whatsapp, setWhatsapp] = useState(existingTutor?.whatsapp || '');
  const [modality, setModality] = useState(existingTutor?.modality || '');
  const [allSubjects, setAllSubjects] = useState([]);

  useEffect(() => {
    const content = require('../../data/horarios.json');
    const unique = [...new Set(content.map(item => item.subject))].sort();
    setAllSubjects(unique);
    setSubjects(unique);
  }, []);

  const handleCareerChange = (event) => {
    const career = event.target.value;
    setSelectedCareer(career);
    if (career === '') {
      const content = require('../../data/horarios.json');
      const unique = [...new Set(content.map(item => item.subject))].sort();
      setSubjects(unique);
    } else {
      const content = require('../../data/horarios.json');
      const filtered = [...new Set(content.filter(item => item.esp === career).map(item => item.subject))].sort();
      setSubjects(filtered);
    }
  };

  const handleSubmit = async () => {
    if (!name || selectedSubjects.length === 0 || !whatsapp || !modality) {
      toast.error('Completá los campos obligatorios.', { position: 'bottom-right', autoClose: 4000, theme: 'dark', transition: Bounce });
      return;
    }

    const tutorData = {
      name,
      subjects: selectedSubjects,
      pricePerHour: pricePerHour !== '' ? Number(pricePerHour) : undefined,
      description,
      whatsapp,
      modality,
    };

    const userId = localStorage.getItem('userId');
    const resp = existingTutor
      ? await updateTutor(userId, tutorData)
      : await createTutor(userId, tutorData);

    if (resp.status === 'success') {
      toast.success(existingTutor ? 'Perfil actualizado' : '¡Perfil creado!', { position: 'bottom-right', autoClose: 3000, theme: 'dark', transition: Bounce });
      setTimeout(() => window.location.reload(), 1000);
    } else {
      toast.error(resp.error || 'Hubo un error.', { position: 'bottom-right', autoClose: 4000, theme: 'dark', transition: Bounce });
    }
  };

  return (
    <div className='add-tutor-background'>
      <div className='add-tutor-container'>
        <h3>{existingTutor ? 'Editar mi perfil' : 'Ofrecer mis servicios'}</h3>
        <div className='add-tutor-hr'></div>

        <FormControl fullWidth>
          <TextField
            style={{ margin: '10px 10px 0' }}
            value={name}
            onChange={e => setName(e.target.value)}
            label="Tu nombre *"
            variant="outlined"
          />

          <Select
            style={{ margin: 10 }}
            value={selectedCareer}
            onChange={handleCareerChange}
            displayEmpty
          >
            <MenuItem value="">Filtrar materias por carrera (opcional)</MenuItem>
            {CAREERS.map(c => <MenuItem key={c.value} value={c.value}>{c.label}</MenuItem>)}
          </Select>

          <Autocomplete
            multiple
            style={{ margin: '0 10px 10px' }}
            options={subjects}
            value={selectedSubjects}
            onChange={(e, val) => setSelectedSubjects(val)}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip key={option} label={option} size="small" {...getTagProps({ index })} />
              ))
            }
            renderInput={(params) => (
              <TextField {...params} label="Materias que das *" placeholder="Buscá una materia..." />
            )}
          />

          <div className='add-tutor-row'>
            <TextField
              style={{ margin: '0 10px 10px', flex: 1 }}
              value={whatsapp}
              onChange={e => setWhatsapp(e.target.value)}
              label="WhatsApp * (ej: 541112345678)"
              variant="outlined"
            />
            <TextField
              style={{ margin: '0 10px 10px', flex: 1 }}
              value={pricePerHour}
              onChange={e => setPricePerHour(e.target.value)}
              label="Precio por hora (opcional)"
              variant="outlined"
              type="number"
            />
          </div>

          <Select
            style={{ margin: '0 10px 10px' }}
            value={modality}
            onChange={e => setModality(e.target.value)}
            displayEmpty
          >
            <MenuItem value="" disabled>Modalidad *</MenuItem>
            <MenuItem value="presencial">Presencial</MenuItem>
            <MenuItem value="virtual">Virtual</MenuItem>
            <MenuItem value="ambas">Presencial y virtual</MenuItem>
          </Select>

          <TextField
            style={{ margin: '0 10px 10px' }}
            value={description}
            onChange={e => setDescription(e.target.value)}
            label="Descripción (opcional)"
            variant="outlined"
            multiline
            rows={3}
            inputProps={{ maxLength: 200 }}
            helperText={`${description.length}/200`}
          />
        </FormControl>

        <button className="btn-create" onClick={handleSubmit}>
          {existingTutor ? 'Guardar cambios' : 'Publicar perfil'}
        </button>
        <button className='btn-cancel' onClick={toggle}>Cancelar</button>
      </div>
      <ToastContainer />
    </div>
  );
};
